import { Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { ABPData, PaymentInformationEntryData } from '../../../../../../models/order/workflow/payment-information-entry.model';


@Injectable({ providedIn: 'root' })
export class PaymentInformationEntryStateService extends BaseWorkflowStateService<PaymentInformationEntryData> {
    override stateKey: string = 'paymentInformationEntry';

    addUpdateABPItem(item: ABPData) {
        if (!item) {
            return;
        }
        const abpList = this.state()?.abpList ?? [];
        const index = abpList.findIndex(abp => abp.flowType === item.flowType);
        if (index !== -1) {
            abpList[index] = item;
        }
        else{
            abpList.push(item);
        }
        this.updateData({
            abpList: abpList
        });
    }
}